import React from "react";

const Loader: React.FC = () => {
	return <div id="spinner" />;
};

export default Loader;
